import { Component, DestroyRef, inject, OnDestroy, signal, Signal } from '@angular/core';
import {TopNavComponent} from '../top-nav/top-nav.component';
import {MatCardModule} from '@angular/material/card';
import {RouterLink, RouterOutlet} from '@angular/router';
import {AuthService} from '../../../services/auth.service';

import {MatIcon} from '@angular/material/icon';
import {LocationService} from '../../../services/location.service';
import { MapService } from '../../../services/map.service';
import {SideNavModule} from '@eagle-i/vulcan-component-library';
import {VulcanSideNavConfig} from '@eagle-i/vulcan-component-library/lib/components/side-nav/models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
  selector: 'tgrid-base-page',
  imports: [TopNavComponent, MatCardModule, RouterOutlet, MatIcon, RouterLink, SideNavModule],
  templateUrl: './base-page.component.html',
  standalone: true,
  styleUrl: './base-page.component.scss',
})
export class BasePageComponent implements OnDestroy {
  protected authService = inject(AuthService);
  protected locationService = inject(LocationService);
  protected mapService = inject(MapService);
  private destroyRef = inject(DestroyRef);

  protected config: Signal<VulcanSideNavConfig> = signal({
    backgroundColor: '#F1F1F1',
    activeRouteColor: '#00662C',
    hoverBorderColor: '#00662c36',
    hoverColor: '#00662c36',
  });





  constructor() {
    this.authService.startSessionPolling();
    this.mapService.initializeGoToPointHandling();
    this.locationService.getAllCounties()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        error: (error) => {
          console.error('Failed to preload counties', error);
        },
      });
  }

  ngOnDestroy() {
    this.authService.stopSessionPolling();
  }

}
